/* script */

  import ApplicationState   from 'g3w-state'
  import GUI                from 'g3w-app';
  import { getUniqueDomId } from 'utils/getUniqueDomId';
  import { gettext as _ }   from 'g3w-i18n';

    const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'spatial-bookmarks',

    data() {
      const gid             = ApplicationState.project.getId();
      const SAVED_BOOKMARKS = JSON.parse(window.localStorage.getItem('SPATIALBOOKMARKS') || '{}');
      SAVED_BOOKMARKS[gid]  = SAVED_BOOKMARKS[gid] || [];
      window.localStorage.setItem('SPATIALBOOKMARKS', JSON.stringify(SAVED_BOOKMARKS || '{}'));

      return {

        /**
         * true = show add dialog menu
         */
        showaddform: false,

        /**
         * spatial bookmarks saved on current QGIS project
         * 
         * bookmark is an array of Object with follow structure:
         * {
         *   name: <String> Unique identifier of spatial bootmark,
         *   removable: <Boolean> true if set in QGIS project, false if add by user on G3W-SUITE application,
         *   extent: <Array> Contain the map bbox coordinates
         * }
         */

        project_bookmarks: ApplicationState.project.state.bookmarks || [],

        user_bookmarks: SAVED_BOOKMARKS[gid],

        addbookmarkinput: null,
      }
    },

    computed: {

      /** @since 3.10.0 */
      is_staff() {
        return window.initConfig.user.is_staff;
      },

      /** @since 3.10.0  */
      lang() {
        return ApplicationState.language;
      },

      /** @since 4.0.0 */
      is_mobile() {
        return window.innerWidth < 767;
      }

    },

    watch: {
      async showaddform(bool) {
        // remove all "col-sm-12" classes so input is adapted to 100% width
        if (bool) {
          this.$refs.add_bookmark.showModal();
        } else {
          this.$refs.add_bookmark.close();
        }
      },
    },

    methods: {

      /**
       * @param bookmark @since 4.1.0
       */
      async shareBookmark({ extent, crs }) {
        await this.gotoSpatialBookmark({ extent, crs });
        GUI.getPermalink(new URL(window.location.href), {});
      },

      addBookMark() {
        this.user_bookmarks.push({
          id:        getUniqueDomId(),
          name:      this.addbookmarkinput,
          extent:    GUI.getMapExtent(),
          removable: true,
          crs:       { epsg: 1 * GUI.getCrs().split('EPSG:')[1] }
        });

        this.saveUserBookMarks();
        this.showaddform = false;
      },

      removeBookMark(id) {
        this.user_bookmarks = this.user_bookmarks.filter(b => id !== b.id);
        this.saveUserBookMarks();
      },

      saveUserBookMarks() {
        const gid             = ApplicationState.project.getId();
        const SAVED_BOOKMARKS = JSON.parse(window.localStorage.getItem('SPATIALBOOKMARKS') || '{}');
        SAVED_BOOKMARKS[gid]  = this.user_bookmarks || [];
        window.localStorage.setItem('SPATIALBOOKMARKS', JSON.stringify(SAVED_BOOKMARKS || '{}'));
      },

      showAddForm() {
        this.addbookmarkinput = null;
        this.showaddform      = true;
      },

      async gotoSpatialBookmark({ extent, crs }) {
        // automatically hide sidebar on mobile
        if (window.innerWidth < 767) {
          GUI.hideSidebar();
        }
        if (crs.epsg !== GUI.getEpsg().split('EPSG:')[1]) {
          const projection = await ApplicationState.projections.set(`EPSG:${crs.epsg}`);
          extent = ol.proj.transformExtent(extent, projection, GUI.getProjection())
        }
        // make use of `force: true` parameter to get resolution from computed `extent`
        await GUI.zoomToExtent(extent, { force: true });
      },

      /**
       * @since 4.1.0
       */
      onBeforetoggle(e) {
        if ('closed' === e.newState) {
          this.showaddform = false;
        }
      },

    },

    created() {
      this.$on('close', () => this.showaddform = false);
    },

  };


/* template */
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"treeview-menu menu-items",attrs:{"id":"g3w-spatial-bookmarks"}},[(_vm.is_staff)?_c('li',{staticClass:"content-bookmarks",staticStyle:{"display":"flex","justify-content":"space-between","background":"transparent","border-radius":"0","cursor":"unset"}},[_c('span',{attrs:{"hidden":_vm.is_mobile}},[_vm._v(_vm._s(_vm.$t('Project Bookmarks')))]),_vm._v(" "),_c('a',{staticStyle:{"padding":"5px 0"},attrs:{"hidden":_vm.is_mobile,"href":`https://docs.qgis.org/3.34/${_vm.lang}/docs/user_manual/map_views/map_view.html#bookmarking-extents-on-the-map`,"target":"_blank","data-i18n-title":"QGIS Docs","data-placement":"right"}},[_c('i',{staticClass:"fa fa-external-link-alt",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.project_bookmarks),function(bookmark){return [(bookmark.nodes)?_c('li',[_c('details',[_c('summary',[_vm._v(_vm._s(bookmark.name))]),_vm._v(" "),_c('ul',{staticStyle:{"margin-left":"10px"}},_vm._l((bookmark.nodes),function(node){return _c('li',{staticClass:"spatial-bookmark",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(node)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();return _vm.gotoSpatialBookmark(node)}}},[_c('i',{staticClass:"fas fa-bookmark",staticStyle:{"margin-right":"5px","font-size":"0.7em"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(node.name))]),_vm._v(" "),_c('button',{staticClass:"sidebar-button",staticStyle:{"margin-left":"auto","padding":"5px"},attrs:{"type":"button","title":"Share via link","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.shareBookmark(node)}}},[_c('i',{staticClass:"fa fa-share-alt",attrs:{"aria-hidden":"true"}})])])}),0)])]):_c('li',{staticClass:"spatial-bookmark",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)}}},[_c('i',{staticClass:"fas fa-bookmark",staticStyle:{"margin-right":"5px","font-size":"0.7em"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(bookmark.name))]),_vm._v(" "),_c('button',{staticClass:"sidebar-button",staticStyle:{"margin-left":"auto","padding":"5px"},attrs:{"type":"button","title":"Share via link","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.shareBookmark(bookmark)}}},[_c('i',{staticClass:"fa fa-share-alt",attrs:{"aria-hidden":"true"}})])])]}),_vm._v(" "),_c('li',{staticClass:"content-bookmarks",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-top":"10px","background":"transparent","border-radius":"0","cursor":"unset"}},[_c('span',{attrs:{"hidden":_vm.is_mobile}},[_vm._v(_vm._s(_vm.$t('User Bookmarks')))]),_vm._v(" "),_c('button',{staticClass:"sidebar-button",staticStyle:{"padding":"5px","font-size":"1.2em"},attrs:{"type":"button","hidden":_vm.is_mobile,"title":"add"},on:{"click":function($event){$event.stopPropagation();return _vm.showAddForm.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-plus-square",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('dialog',{ref:"add_bookmark",on:{"beforetoggle":_vm.onBeforetoggle}},[_c('div',{staticStyle:{"display":"flex","justify-content":"end"}},[_c('button',{staticClass:"fas fa-times",staticStyle:{"border":"medium","line-height":"1","font-weight":"700","font-size":"15px","background":"none","width":"40px","height":"40px"},attrs:{"type":"button","title":"close"},on:{"click":function($event){$event.stopPropagation();_vm.showaddform = false}}})]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.addBookMark.apply(null, arguments)}}},[_c('label',{attrs:{"for":"add-bokmark"}},[_vm._v(_vm._s(_vm.$t('Name of new spatial bookmark'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addbookmarkinput),expression:"addbookmarkinput"}],ref:"add_bookmark_input",staticClass:"form-control",attrs:{"id":"add-bookmark","type":"text","required":""},domProps:{"value":(_vm.addbookmarkinput)},on:{"input":function($event){if($event.target.composing)return;_vm.addbookmarkinput=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-success",staticStyle:{"margin-top":"20px"},attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('add')))])])])]),_vm._v(" "),_vm._l((_vm.user_bookmarks),function(bookmark){return _c('li',{staticClass:"spatial-bookmark",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();return _vm.gotoSpatialBookmark(bookmark)}}},[_c('i',{staticClass:"fas fa-bookmark",staticStyle:{"margin-right":"5px","font-size":"0.7em"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(bookmark.name))]),_vm._v(" "),_c('button',{staticClass:"sidebar-button",staticStyle:{"margin-left":"auto","margin-right":"5px","padding":"5px"},attrs:{"type":"button","title":"Share via link","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.shareBookmark(bookmark)}}},[_c('i',{staticClass:"fa fa-share-alt",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"sidebar-button",staticStyle:{"color":"red","padding":"5px"},attrs:{"title":"Delete","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.removeBookMark(bookmark.id)}}},[_c('i',{staticClass:"fas fa-trash",attrs:{"aria-hidden":"true"}})])])})],2)
}
var staticRenderFns = []

const __vue_render__ = render;
const __vue_staticRenderFns__ = staticRenderFns;

const __vue_component__ = __vue_script__;
__vue_component__.render = __vue_render__;
__vue_component__.staticRenderFns = __vue_staticRenderFns__;
__vue_component__._compiled = true;
__vue_component__.__file = "/home/volterra79/G3W-SUITE/g3w-client/src/components/SpatialBookMarks.vue";

/* style inject */
import __vue_create_injector__ from 'g3w-vue:style-injector';
[{"id":"6cbed77f-0","css":".content-bookmarks{font-weight:700;color:#fff;padding:5px;border-bottom:1px solid #fff;margin-bottom:2px}.spatial-bookmark{display:flex;align-items:baseline;justify-content:space-between;padding:5px!important}.spatial-bookmark:hover{background-color:var(--bgcolor)!important}#add-bookmark:user-invalid{outline:2px solid red}ul#g3w-spatial-bookmarks>li>details>*{padding:5px}ul#g3w-spatial-bookmarks>li>details>summary{user-select:none}ul#g3w-spatial-bookmarks>li>details>summary::marker{content:\"\\f0da\\a0\\a0\";font-family:\"Font Awesome 5 Free\";font-weight:900}ul#g3w-spatial-bookmarks>li>details[open]>summary::marker{content:\"\\f0d7\\a0\\a0\"}ul#g3w-spatial-bookmarks>li>details[open]>summary{border-bottom:2px solid #2c3b41}\n","media":"","filename":"src/components/SpatialBookMarks.vue"}].forEach(__vue_create_injector__());
export default __vue_component__;